export const LABEL_TENANTS_SWITCHER = 'Tenants Switcher'
export const VIEWING = 'Currently Viewing'
export const LABEL_NO_RESULTS = 'No Results'
export const LABEL_SHOW_ALL_RESULTS = 'Show all {0} results ...'
export const LABEL_SEARCH_RESULTS = 'SEARCH RESULTS'
export const LABEL_IN_PROGRESS = 'In Progress'
